import { render, staticRenderFns } from "./Flowy.vue?vue&type=template&id=fc717a8a&language=html"
import script from "./Flowy.vue?vue&type=script&lang=js"
export * from "./Flowy.vue?vue&type=script&lang=js"
import style0 from "./Flowy.vue?vue&type=style&index=0&id=fc717a8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports